import { Component, Input } from '@angular/core';

@Component({
	selector: 'image-in-aspect-ratio',
	templateUrl: './image-in-aspect-ratio.component.html',
	styleUrls: ['./image-in-aspect-ratio.component.scss']
})
export class ImageInAspectRatioComponent {

	@Input() wrapper_classes : string = "";
	@Input() wrapper_style : string = "";

	/**
	 * Mantener en números pares por favor
	 */
	@Input() width! : string;

	/**
	 * Expresado en número, como porcentaje del ancho, pero sin %. Ejemplos: Para un cuadrado exacto, 100. Para un rectángulo cuya altura es la mitad del ancho, 50.
	 */
	@Input() aspect_ratio! : number;
	@Input() img_src! : string;
	@Input() object_fit : "cover"|"contain" = "cover";

	@Input() withHover : boolean = false;
	/**
	 * El boolean es para bindear el estilo on hover, no para activarlo. El estilo on hover solo se va a ver cuando esta variable esté en true. El estilo on hover está definido en este mismo componente.
	 */
	@Input() hoverOn : boolean = false;

	@Input() alt = "";

}
